import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

const CtaFinalSection: React.FC = () => {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        py: { xs: 9, md: 12 },
        background: 'linear-gradient(135deg, #0A2038 0%, #123A61 100%)',
        color: '#fff',
        '&::before': {
          content: '""',
          position: 'absolute',
          width: 480,
          height: 480,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(45, 212, 191, 0.22) 0%, transparent 70%)',
          top: -220,
          left: '50%',
          transform: 'translateX(-50%)',
        },
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <Typography variant="h2" sx={{ fontSize: { xs: '1.9rem', md: '2.5rem' }, mb: 2.5 }}>
            Seu próximo plano de saúde pode começar com uma boa análise.
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.05rem', lineHeight: 1.7, mb: 4, maxWidth: 560, mx: 'auto' }}>
            Converse com nossa equipe e descubra quais opções podem fazer sentido para você.
          </Typography>
          <Button
            component="a"
            href="#cotacao"
            variant="contained"
            size="large"
            endIcon={<ArrowForwardRoundedIcon />}
            sx={{
              bgcolor: 'secondary.main',
              color: '#0A2038',
              fontWeight: 700,
              '&:hover': { bgcolor: 'secondary.light' },
            }}
          >
            Solicitar Cotação Agora
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default CtaFinalSection;
